import { styled, Typography } from '@mui/material';

export const HeaderW = styled('div')`
  display: flex;
  align-items: flex-start;
  padding-top: 16px;
  padding-bottom: 16px;

  @media (max-width: 1023px) {
    margin-bottom: 16px;
    padding-top: 0px;
  }
`;

export const PageTitle = styled(Typography)`
  font-weight: 700;
  font-size: 32px;
  color: ${({ theme }) => theme.palette.primary.p080};
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 32px;
    line-height: 28px;
  }
`;

export const CloseButtonW = styled('div')`
  margin-left: auto;
  position: fixed;
  top: 79px;
  right: 88px;
  cursor: pointer;
  @media (max-width: 1023px) {
    position: static;
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
